import { Link } from "./common";
const baseLinkData = {};
const LinkData = {
  fromJSON(object) {
    const message = { ...baseLinkData };
    message.link = object.link !== void 0 && object.link !== null ? Link.fromJSON(object.link) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.link !== void 0 && (obj.link = message.link ? Link.toJSON(message.link) : void 0);
    return obj;
  }
};
export {
  LinkData
};
//# sourceMappingURL=decoration_link.js.map
